<!-- One aside, always rendered, with collapse expressed as a class rather than a branch. Projected
     content is never inside an @if: ng-content in a conditional destroys and recreates the surface
     on every toggle, which is the remount this design exists to avoid. -->
<aside class="board-panel">

  <!-- Resize grip on the leading edge. Emits raw pointer events; the board owns the geometry,
       because clamping needs the manifest bounds and the board's own rect. Hidden while collapsed
       and while floating at a size the board cannot split. -->
  @if ($resizable() && $presentation() === 'side') {
    <div class="board-panel-resize-handle" (pointerdown)="resizeStart.emit($event)" (pointermove)="resizeMove.emit($event)" (pointerup)="resizeEnd.emit($event)" (pointercancel)="resizeEnd.emit($event)" (dblclick)="resizeReset.emit()"></div>
  }

  @if ($ownsHeader()) {
    <!-- Jobs QuickView: no w-page, so this is the title/pin/close bar. Task Detail sets ownsHeader
         false — the panel is only the resizable box, and w-page draws the real editor header. -->
    <div class="head">
      @if ($canStep()) {
        <!-- Leading, so the arrows stay put while the title length changes from record to record. -->
        <div class="panel-stepper">
          <wb-button-icon class="panel-head-btn" iconLeft="fa-regular fa-chevron-up" displayStyle="Tertiary" size="Small" [tooltip]="$hold() ?? 'Previous record'" [disabled]="!$stepPosition()?.canPrevious" (onClick)="onStep(-1)" />
          <wb-button-icon class="panel-head-btn" iconLeft="fa-regular fa-chevron-down" displayStyle="Tertiary" size="Small" [tooltip]="$hold() ?? 'Next record'" [disabled]="!$stepPosition()?.canNext" (onClick)="onStep(1)" />
          @if ($stepLabel(); as stepLabel) {
            <span class="panel-step-position">{{ stepLabel }}</span>
          }
        </div>
      }
      @if ($title(); as title) {
        <span class="panel-title" [tooltip]="$titleTooltip()" [display]="!!$titleTooltip()">{{ title }}</span>
      }
      <div class="panel-head-actions">
        @if ($expand().tooltip; as tooltip) {
          <wb-button-icon class="panel-head-btn" iconLeft="fa-regular fa-up-right-and-down-left-from-center" displayStyle="Tertiary" size="Small" [tooltip]="$hold() ?? tooltip" (onClick)="expand()" />
        }
        @if ($expand().canDock) {
          <wb-button-icon class="panel-head-btn" iconLeft="fa-regular fa-down-left-and-up-right-to-center" displayStyle="Tertiary" size="Small" [tooltip]="$hold() ?? 'Dock to side'" (onClick)="dock()" />
        }
        @if ($recordPageUrl()) {
          <wb-button-icon class="panel-head-btn" iconLeft="fa-solid fa-arrow-up-right-from-square" displayStyle="Tertiary" size="Small" [tooltip]="$hold() ?? 'Open record page'" (onClick)="openRecordPage()" />
        }
        @if ($pinAvailable()) {
          <wb-button-icon class="panel-head-btn" [iconLeft]="$pinIcon()" displayStyle="Tertiary" size="Small" [disabled]="$pinDisabled()" [tooltip]="$pinTooltip()" (onClick)="onTogglePin()" />
        }
        <wb-button-icon class="panel-head-btn" iconLeft="fa-regular fa-xmark" displayStyle="Tertiary" size="Small" tooltip="Close panel" (onClick)="onClose()" />
      </div>
    </div>
  }

  <div class="body" [class.is-empty]="$empty()">
    <ng-content />
    <!-- Reached by a preview only: it holds the split open regardless of selection. A quickview is
         selection-driven and unmounts instead, so it never shows this. -->
    @if ($empty()) {
      <div class="board-panel-state">
        <i class="fa-regular fa-file-lines"></i>
        <span>No document selected</span>
      </div>
    }
  </div>

</aside>
